import BigTable from './BigTable';

export default BigTable;
